import { render, staticRenderFns } from "./ListInstitutionTypes.vue?vue&type=template&id=5d59c3fb&"
import script from "./ListInstitutionTypes.vue?vue&type=script&lang=js&"
export * from "./ListInstitutionTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d59c3fb')) {
      api.createRecord('5d59c3fb', component.options)
    } else {
      api.reload('5d59c3fb', component.options)
    }
    module.hot.accept("./ListInstitutionTypes.vue?vue&type=template&id=5d59c3fb&", function () {
      api.rerender('5d59c3fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListInstitutionTypes.vue"
export default component.exports